<div class="tile" [class.selected]="selected()" (click)="change()">
  <h6>{{day()}}</h6>
  <p>{{date()}}</p>
</div>